import {
	createStyles,
	fade,
	Theme,
	withStyles,
} from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import InputLabel from '@material-ui/core/InputLabel'
import { ReactElement } from 'react'
import useMobile from 'components/hooks/useMobile'

interface IProps {
	label: string,
	placeholder: string,
	name: string,
	onChange(event: React.ChangeEvent<HTMLInputElement>): void,
	value: string,
}

const Input = withStyles((theme: Theme) =>
	createStyles({
		root: {
			'label + &': {
				color: '#1e1e1e',
			},
		},
		input: {
			borderRadius: 8,
			backgroundColor: 'transparent',
			border: '1px solid #c4c4c4',
			fontSize: 14,
			padding: '8px 12px',
			transition: theme.transitions.create(['border-color', 'box-shadow']),
			'&:focus': {
				boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
				borderColor: theme.palette.primary.main,
			},
		},
	}),
)(InputBase)

export default function CustomizedInputs(props: IProps): ReactElement {
	const { label, placeholder, name, onChange, value } = props
	const mobile = useMobile()
	return (
		<>
			<InputLabel
				shrink
				htmlFor="input"
				style={{color: '#1e1e1e', margin: '0px 6px'}}
			>
				{label}
			</InputLabel>
			<Input
				name={name}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				id={name}
				fullWidth={true}
				style={ mobile ? {width: '97%', margin: '3px', padding: '3px'} : {width: '100%', margin: '3px', padding: '3px'} }
				autoComplete='nope'
			/>
		</>
	)
}
